import React from 'react';

const OAuthCallback  = () => { 
  return (
  <div>
    <h1>Token Received</h1>
    <p>Copy the full URL from your browser and send it to Matt.</p>
  </div>
  )
}

export default OAuthCallback;